import { useState } from 'react';
import useDebounce from './useDebounce';

const dummySuggestions = [
  {
    document: { q: 'alpinestars' },
  },
];

export const useSearchBoots = () => {
  const [showSearchPreview, setShowSearchPreview] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  return {
    showSearchPreview,
    setShowSearchPreview,
    searchTerm,
    setSearchTerm,
    debouncedSearchTerm,
  };
};
